<button
  class="portal-link-btn"
  type="button"
  (click)="navigateToProposalPortal()"
  [matTooltip]="'APPLAYOUT.HEADER.PROPOSAL_PORTAL_TOOLTIP' | translate"
  matTooltipPosition="below"
>
  {{ 'APPLAYOUT.HEADER.PROPOSAL_PORTAL' | translate }}
  <fa-icon size="1x" icon="external-link-alt"></fa-icon>
</button>
